import { RoleDto } from "@merchant_api/models/role-dto";

export class RolesState {
    loading = false;
    error = null;
    record: Array<RoleDto> = [];
}
